import { c as _c } from "react/compiler-runtime";
import { useInView } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import Image, { StaticImageData } from 'next/image';
import appPreviewMockupDefault from '@/assets/images/appPreviewMockup.png';
import heartMobile from '@/assets/images/heart-shows-heart.png';
import heartDesktop from '@/assets/images/heart-holds-phone.png';
import brainMobile from '@/assets/images/brain-thumb-up.png';
import brainDesktop from '@/assets/images/brain-holds-phone.png';
import { SectionHeadline } from '@/components/SectionHeadline';
import { mergeClasses } from '@/utils/style';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
function AppIntro(t0) {
  const $ = _c(38);
  const {
    appPreviewMockup,
    className,
    title,
    cta,
    video,
    anchorKey: t1
  } = t0;
  const anchorKey = t1 === undefined ? "appIntro.title" : t1;
  const elementRef = useRef(null);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isInView = useInView(elementRef, t2);
  let t3;
  let t4;
  if ($[1] !== isInView) {
    t3 = () => {
      if (isInView) {
        setIsVisible(true);
      }
    };
    t4 = [isInView];
    $[1] = isInView;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] !== video) {
    t5 = video.replace(".mp4", ".webm");
    $[4] = video;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const webmUrl = t5;
  let t6;
  if ($[6] !== className) {
    t6 = mergeClasses("w-full overflow-hidden", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== anchorKey || $[9] !== title) {
    t7 = <SectionHeadline className="mx-auto mb-10 max-w-192 lg:mb-16" anchorKey={anchorKey}>{title}</SectionHeadline>;
    $[8] = anchorKey;
    $[9] = title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute top-1/2 right-0 left-0 h-[27.5rem] w-full -translate-y-1/2 overflow-x-hidden lg:h-[35rem]"><div className="bgCircle absolute top-1/2 left-1/2 h-[27.5rem] w-[27.5rem] -translate-x-1/2 -translate-y-1/2 lg:h-[35rem] lg:w-[35rem]" /></div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = appPreviewMockup || appPreviewMockupDefault;
  let t10;
  if ($[12] !== t9) {
    t10 = <Image src={t9} alt="iPhone" width={320} className="relative z-10 w-70 lg:w-80" loading="lazy" />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Image src={heartMobile} alt="" width={296} className="absolute -right-6 -bottom-[72px] z-10 lg:hidden" loading="lazy" />;
    t12 = <Image src={brainMobile} alt="" width={198} className="absolute -bottom-20 -left-10 z-10 lg:hidden" loading="lazy" />;
    t13 = <Image src={heartDesktop} alt="" width={277} quality={90} className="absolute bottom-8 left-full z-10 -ml-[22px] hidden lg:inline-block" loading="lazy" />;
    t14 = <Image src={brainDesktop} alt="" width={255} quality={90} className="absolute right-full bottom-8 z-10 -mr-3 hidden lg:inline-block" loading="lazy" />;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t14 = $[17];
  }
  let t15;
  if ($[18] !== isVisible || $[19] !== webmUrl) {
    t15 = isVisible && <source src={webmUrl} type="video/webm" />;
    $[18] = isVisible;
    $[19] = webmUrl;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== isVisible || $[22] !== video) {
    t16 = isVisible && <source src={video} type="video/mp4" />;
    $[21] = isVisible;
    $[22] = video;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t15 || $[25] !== t16) {
    t17 = <div className="absolute top-2 right-2 bottom-2 left-2 z-0 overflow-hidden rounded-4xl bg-blue-500 px-1 py-[3px] drop-shadow-2xl md:px-1.5 md:py-[5px]"><video preload="none" muted={true} autoPlay={true} loop={true} playsInline={true} ref={videoRef}>{t15}{t16}Your browser does not support the video tag.</video></div>;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t10 || $[28] !== t17) {
    t18 = <div className="relative pb-20 text-center">{t8}<div className="relative z-10 inline-block">{t10}{t11}{t12}{t13}{t14}{t17}</div></div>;
    $[27] = t10;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = LINKS();
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== cta) {
    t20 = <Button align="center" size="lg" variant="secondary" analyticsParam="appDownload" testId="appDownload" to={t19.mobileApp}>{cta}</Button>;
    $[31] = cta;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t18 || $[34] !== t20 || $[35] !== t6 || $[36] !== t7) {
    t21 = <div className={t6} ref={elementRef}>{t7}{t18}{t20}</div>;
    $[33] = t18;
    $[34] = t20;
    $[35] = t6;
    $[36] = t7;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  return t21;
}
export default AppIntro;